import { render, staticRenderFns } from "./BoxHead.vue?vue&type=template&id=7d5f37ed&"
import script from "./BoxHead.vue?vue&type=script&lang=js&"
export * from "./BoxHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports